import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";
import { jsx as ___EmotionJSX } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @jsx jsx */


import { jsx } from 'theme-ui';
import { theme, useConfig, ComponentsProvider } from 'docz';
import { Styled, ThemeProvider } from 'theme-ui';
import defaultTheme from '~theme';
import components from '~components';

var Theme = function Theme(_ref) {
  var children = _ref.children;
  var config = useConfig();
  return jsx(ThemeProvider, {
    theme: config.themeConfig
  }, jsx(ComponentsProvider, {
    components: components
  }, jsx(Styled.root, null, children)));
};

export var enhance = theme(defaultTheme, function (_ref2) {
  var _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'light' : _ref2$mode,
      _ref2$showPlaygroundE = _ref2.showPlaygroundEditor,
      showPlaygroundEditor = _ref2$showPlaygroundE === void 0 ? true : _ref2$showPlaygroundE,
      _ref2$showLiveError = _ref2.showLiveError,
      showLiveError = _ref2$showLiveError === void 0 ? true : _ref2$showLiveError,
      config = _objectWithoutPropertiesLoose(_ref2, ["mode", "showPlaygroundEditor", "showLiveError"]);

  return _objectSpread({}, config, {
    showLiveError: showLiveError,
    showPlaygroundEditor: showPlaygroundEditor,
    initialColorMode: mode
  });
});

if (typeof enhance !== 'undefined' && enhance && enhance === Object(enhance) && Object.isExtensible(enhance)) {
  Object.defineProperty(enhance, '__filemeta', {
    configurable: true,
    value: {
      name: "enhance",
      filename: "node_modules/gatsby-theme-docz/src/index.js"
    }
  });
}

export default enhance(Theme);